import React from 'react';
import {
  Row, Col, Typography, Card, Form, Button,
} from 'antd';
import PropTypes from 'prop-types';
import ArrowLeftIcon from 'mdi-react/ArrowLeftIcon';
import SelectedLands from '../../../serviceComponents/selectedLands/SelectedLands';
import GeoMapSummary from '../../../serviceComponents/geoMapSummary/GeoMapSummary';
import DetailsFields from '../detailsFields/DetailsFields';
import './Details.scss';

const Details = (props) => {
  const {
    removeSelectedField, serviceRequestParameters, nextPage, previousPage,
  } = props;

  const [formInstance] = Form.useForm();

  const handleSubmit = (values) => {
    nextPage({
      ...serviceRequestParameters,
      details: {
        ...values,
      },
    });
  };

  return (
    <div className="VantMapeamentoLinhasDetails">
      <Row
        justify="space-between"
        className="VantMapeamentoLinhasDetails__TitleRow"
      >
        <Col
          className="VantMapeamentoLinhasDetails__TitleCol"
        >
          <Typography.Title
            level={1}
            className="VantMapeamentoLinhasDetails__Title"
          >
            Novo Serviço: Vant
          </Typography.Title>
        </Col>
      </Row>
      <Row
        gutter={[24, 24]}
        className="VantMapeamentoLinhasDetails__ContentRow"
      >
        <Col
          span={24}
          className="VantMapeamentoLinhasDetails__ContentColumn"
        >
          <Card
            className="VantMapeamentoLinhasDetails__ContentCard"
          >
            <Row
              gutter={[24, 24]}
              className="VantMapeamentoLinhasDetails__FormRow"
            >
              <Col
                xs={{ span: 24 }}
                lg={{ span: 12 }}
                className="VantMapeamentoLinhasDetails__FormColumn"
              >
                <Form
                  scrollToFirstError
                  className="VantMapeamentoLinhasDetails__Form"
                  layout="vertical"
                  form={formInstance}
                  onFinish={handleSubmit}
                  onFinishFailed={
                    (errorInfo) => {
                      console.log('VantMapeamentoLinhasDetails onFinishFailed', errorInfo);
                      console.log('fields', formInstance.getFieldsValue());
                    }
                  }
                >
                  <DetailsFields
                    formInstance={formInstance}
                    initialValuesObject={
                      serviceRequestParameters
                        ?.serviceRequestFieldInputList?.length
                        ? Object.fromEntries(
                          serviceRequestParameters
                            ?.serviceRequestFieldInputList
                            ?.map(
                              (val) => {
                                return [val.idCode, val.value];
                              },
                            ),
                        )
                        : undefined
                    }
                    mode="CREATE"
                  />
                </Form>
              </Col>

              <Col
                xs={{ span: 24 }}
                lg={{ span: 12 }}
                className="VantMapeamentoLinhasDetails__LandAndSummaryColumn"
              >
                <SelectedLands
                  talhoesSelecionados={serviceRequestParameters.talhoesSelecionados}
                  removeSelectedField={removeSelectedField}
                />
                <GeoMapSummary params={serviceRequestParameters} />
              </Col>
            </Row>

            <Row
              gutter={[24, 24]}
              justify="end"
              className="VantMapeamentoLinhasDetails__ButtonRow"
            >
              <Col
                xs={{ span: 24 }}
                md={{ span: 12 }}
                lg={{ span: 6 }}
                className="VantMapeamentoLinhasDetails__ButtonFirstColumn"
              >
                <Button
                  block
                  className="VantMapeamentoLinhasDetails__BackButton"
                  onClick={() => previousPage()}
                >
                  <ArrowLeftIcon className="VantMapeamentoLinhasDetails__ArrowLeftIcon" />
                  Voltar
                </Button>
              </Col>
              <Col
                xs={{ span: 24 }}
                md={{ span: 12 }}
                lg={{ span: 6 }}
                className="VantMapeamentoLinhasDetails__ButtonSecondColumn"
              >
                <Button
                  block
                  type="primary"
                  htmlType="submit"
                  className="VantMapeamentoLinhasDetails__ContinueButton"
                  onClick={
                    (eventt) => {
                      eventt.preventDefault();
                      formInstance.submit();
                    }
                  }
                >
                  Continuar
                </Button>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

Details.propTypes = {
  removeSelectedField: PropTypes.func.isRequired,
  nextPage: PropTypes.func.isRequired,
  previousPage: PropTypes.func.isRequired,
  serviceRequestParameters: PropTypes.shape({
    serviceRequestFieldInputList: PropTypes.arrayOf(PropTypes.shape({})),
    serviceTypeDynamicFields: PropTypes.arrayOf(PropTypes.any).isRequired,
    serviceSubtypeDynamicFields: PropTypes.arrayOf(PropTypes.any),
    service: PropTypes.string,

    talhoesSelecionados: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        area: PropTypes.number,
        culture: PropTypes.shape({}),
        details: PropTypes.string,
        landId: PropTypes.number,
        name: PropTypes.string,

        polygon: PropTypes.arrayOf(
          PropTypes.shape({
            lat: PropTypes.number,
            lon: PropTypes.number,
          }),
        ),
      }),
    ),
  }).isRequired,
};
Details.defaultProps = {};

export default Details;
